import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import Pagination from '../reusable/Pagination'
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { BuscarProductoOfertas } from '../../store/sagas/pedidoApi';
import { AgregarProductoCarrito, BuscarCarritoPedido } from '../../store/sagas/carritoApi';
import { notificacion, numberWithCommas, getStatePage } from '../../utilitarios/util';

import { data } from '../../constants/Constants';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";
import CardPrecioOferta from '../reusable/CardPrecioOferta';
import BtnCompatible from '../reusable/BtnCompatible';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import ModalAddCart from "../reusable/modals/AddCart";
import ModalSinStock from "../reusable/modals/SinStock";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import ModalCompatible from '../reusable/modals/Compatible';

const CardOferta = ({ oferta, postAgregarProductoPedido, postAgregarProductoFavorito, setCounter, auth, compatible }) => {

  return (
    <div className="card_product_horizontal card_oferta gradient_blue">
      <div className="cphTextLeft">
        <div className="tag">
          <SvgAssets icon="icon-oferta" className="icon-oferta" fill={c.rojoClaro} />
          <SvgAssets icon="icon-tag" />
        </div>
        <h6 className="paragraph-2 bold mb-1 mt-4" style={{ color: '#fff', wordBreak: 'break-word' }}>{oferta.maktx}</h6>
        <span className="paragraph-3 mb-3" style={{ color: '#fff' }}>SKU: {oferta.matnr}</span>
        <span className="paragraph-3" style={{ color: '#fff' }}>Total: {oferta.sWaers} {numberWithCommas(oferta.subTotal)}</span>
      </div>
      <div className="cphTextCenter pl-0">
        {/* <span className="paragraph-3 pu" style={{ color: '#fff' }}>P.U.</span> */}
        {/* <span className="paragraph-3 previousPrice mt-4" style={{ color: '#fff' }}>{oferta.precioPublico}</span>
        <span className="paragraph-3" style={{ color: '#fff' }}>{oferta.precioPVD}</span>
        <span className="paragraph-3" style={{ color: '#fff' }}>{oferta.precioPVP}</span> */}
        <CardPrecioOferta data={oferta.precios} className="cardPrice mt-4" />
        <div className="text-left mt-2 options">
          {/* <BtnCompatible IdInput={oferta.idInput} texto={oferta.mensajeCompatible} /> */}
          <button className='btn-icon'
            type="button"
            onClick={() => compatible(oferta.mensajeCompatible)}
          >
            <SvgAssets icon="icon-compatible" fill={c.azulClaro} />
          </button>
          <button type="button"
            onClick={() => postAgregarProductoFavorito({
              codigo: oferta.matnr, descripcion: oferta.maktx,
              moneda: oferta.waers, pantalla: data.Pantalla.Catalogo.Ofertas
            }, oferta.favorito, oferta.indice)}
            className="btn-icon">
            <SvgAssets icon="icon-star" fill={oferta.favorito ? c.amarillo : c.celeste} />
          </button>
          <button className={`btn-icon${(oferta.cantidad == 0 ? " disabled" : "")}`}
            type="button"
            disabled={oferta.cantidad == 0}
            onClick={() => postAgregarProductoPedido(auth.carritoProdctos, auth.setcarritoProdctos, oferta, data.Pantalla.Carrito.Ofertas)}
          >
            <SvgAssets icon="icon-add-cart" fill={oferta.favorito ? c.amarillo : c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.azulClaro, justifyContent: 'space-between' }}>
        <span className="paragraph-3" style={{ color: '#fff' }}>Cantidad</span>
        <CounterInput
          vertical
          background={c.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
          data={oferta}
          eventCounter={setCounter}
        />
      </div>
    </div>
  )
}

export class CarritoOfertas extends Component {
  static displayName = CarritoOfertas.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      productosOfertas: [],
      alertas: [],
      page: 1,
      size: data.PageSizeOfertas,
      currentPage: 1,
      totalPorCantidad: null,
      datosTotal: {},
      productos: [],
      localId: 0,
      pedidoId: 0,
      addToCart: false,
      dataToCard: {},
      textBuscador: "",
      errorCodigo: false,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      addStock: false,
      isEmpty: false,
      TOTAL_REGISTROS: 0,
      modalZoom: false,
      modalCompatible: false,
      mensajeCompatible: '',
      imgZoom: "",
    };
  }
  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }
  toggleModalCompatible = (texto) => {
    this.setState(prevState => ({
      modalCompatible: !prevState.modalCompatible,
      mensajeCompatible: texto
    }));
  }
  // showCarrito = () => {
  //   this.setState({ addToCart: false, loading: false }, () => {
  //     let datosBuscador = { localId: 0 };
  //     this.props.history.push({
  //       pathname: '/carrito',
  //       state: {
  //         datosBuscador
  //       }
  //     });
  //   });
  // }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        let datosBuscador = { localId: 0 };
        this.props.history.push({
          pathname: '/carrito',
          state: {
            datosBuscador
          }
        });
      }, 1000);
    });
  }
  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      let _datosTotal = state.datosTotal;
      let _datosProductos = state.datosProductos;
      this.setState({
        datosTotal: _datosTotal,
        productos: _datosProductos,
        // pedidoId: params.pedidoId,
        localId: state.localId
      });
      console.log("Ofertas=====>", state.localId);
    }
  }
  load = () => {
    let dataS = localStorageCustom.prototype.getUsuario()

    this.setState({
      errorCodigo: false,
      textBuscador: "",
      page: 1,
      currentPage: 1,
      loading: true,
      dealer: dataS.dealer,
      linea: dataS.linea,
      asociado: dataS.asociado,
      addStock: false
    }, () => {
      // this.postBuscarProductoOfertas(data.dealer, data.linea, data.asociado, this.IrCarritoEnvio);
      BuscarCarritoPedido(dataS.dealer, dataS.linea, dataS.asociado, 0, 0)
        .then(result => {
          if (result.mo.type == "success") {
            let productosSinStock = result.dto.repuestos.filter(t => !t.validaStok).length;
            let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;


            this.setState({
              loading: productosSinStock == 0,
              addStock: productosSinStock > 0,
              TOTAL_REGISTROS: _total
            }, async () => {
              if (_total == 0)
                notificacion("Carrito", data.MensajeSinProducto);

              if (productosSinStock == 0)
                this.postBuscarProductoOfertas(dataS.dealer, dataS.linea, dataS.asociado, 1);
            })
          } else {
            throw new Error(result.mo.listMessage.join(", "));
          }
        }).catch((error) => {
          this.setState({ loading: false }, async () => {
            error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
            notificacion("Carrito", error.message ?? null);
          });
        });

    });
  }



  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      this.load();
      this.checkParams();
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  IrListado = async () => {
    this.props.history.push('/carrito');
  }

  render() {
    const { TOTAL_REGISTROS, errorCodigo, datosTotal, loading, productosOfertas, page, size, currentPage, alertas, isEmpty } = this.state;
    const auth = this.context;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-oferta" fill='#fff' />Ofertas</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li><Link to='/carrito'>Carrito de compras</Link></li>
              <li>Ofertas</li>
            </ul>
          </Container>
        </div>
        <Container className="pt-5 pb-float">
          <FormGroup className="icon mb-4" style={{ maxWidth: 255, margin: 'auto' }}>
            <Input className="" type='text' placeholder="SKU o Descripción" onChange={(text) => this.searchProductos(text)}
              onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); this.IrBuscar() } }}
            />
            <Button color="link" className="btn-icon" onClick={() => { this.IrBuscar() }}>
              <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
            </Button>
          </FormGroup>
          <h6 className="title white mobile"><Link to='/carrito' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link><SvgAssets icon="icon-oferta" fill="#fff" />Ofertas</h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#2861c2" />
            <TooltipLeyenda
              color={c.azulClaro}
              style={{ marginLeft: 'auto', paddingRight: 10, top: -15, position: 'relative' }}
            />
            <div className="cards-wrap">
              {productosOfertas.map((item, index) => {
                return (
                  <CardOferta key={index} oferta={item} postAgregarProductoPedido={this.postAgregarProductoPedido} postAgregarProductoFavorito={this.postAgregarProductoFavorito} setCounter={this.setCounter} auth={auth} compatible={this.toggleModalCompatible} />
                )
              })}
            </div>
            {(productosOfertas.length > 0) ?
              <Pagination
                event={this.setPage}
                current={page}
                currentPage={currentPage}
                totalPage={productosOfertas[0].totalPage}
                size={data.PageSizePaginator} /> : null}
          </div>
        </Container>
        <div className="float_section">
          <SvgAssets icon="curve-top" className="curve" fill={c.azul} />
          <p className="total-price">TOTAL: <span>{datosTotal.moneda} {(Number(TOTAL_REGISTROS > 0 ? datosTotal.total : TOTAL_REGISTROS)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span></p>
          <button
            className={`btn-block${(TOTAL_REGISTROS == 0 ? " disabled" : "")}`}
            type="button"
            disabled={TOTAL_REGISTROS == 0}
            onClick={() => this.IrCarritoEnvio()}>siguiente</button>
        </div>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalSinStock dadComponent={this} />
        <ModalImageZoom dadComponent={this} />
        <ModalCompatible dadComponent={this} texto={this.state.mensajeCompatible} />
      </div>
    );
  }


  IrCarritoEnvio = async () => {
    this.props.history.push({
      pathname: '/carrito/envio',
      state: {
        datosTotal: this.state.datosTotal,
        localId: this.state.localId,
        pedidoId: this.state.pedidoId
      }
    });
  }
  searchProductos = (e) => {
    let text = e.currentTarget.value;
    console.log("searchProductos===>", text);
    this.setState({ textBuscador: text.toUpperCase() });
  }
  postBuscarProductoOfertas(dealer, linea, asociado, index, fn = null) {
    this.setState({
      loading: true,
      addStock: false
    })
    BuscarProductoOfertas(linea.vkorg, dealer.codcliente,
      dealer.correoElectronico, asociado.poblacion, asociado.moneda, linea.centro,
      data.Sistema, this.state.size, index, this.state.textBuscador, data.Pantalla.Carrito.Ofertas,
      data.Pantalla.Carrito.Etiqueta.Ofertas)
      .then(result => {
        if (result.mo.type == "success") {
          // if (typeof fn == "function") {
          //   if ((result.dto.repuestos || []).length == 0) fn();
          // }
          this.setState({
            loading: false,
            productosOfertas: result.dto.repuestos,
            alertas: result.dto.alertas
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }


  IrBuscar = () => {
    debugger;
    if (this.state.textBuscador == "" || this.state.textBuscador.length >= data.BuscadorCodigoLongitud) {
      this.setState({
        errorCodigo: false,
        loading: true,
        page: 1
      }, () => {
        this.postBuscarProductoOfertas(this.state.dealer, this.state.linea, this.state.asociado, 1);
      })
    } else {
      this.setState({
        errorCodigo: true
      })
    }
  }
  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    this.postBuscarProductoOfertas(this.state.dealer, this.state.linea, this.state.asociado, index);
  }
  setCounter = (counter, item, index) => {
    let _destacados = this.state.productosOfertas

    if (counter == "") {
      _destacados[index].cantidad = 0;
      _destacados[index].subTotal = 0;
    } else {
      _destacados[index].cantidad = counter;
      _destacados[index].subTotal = Number((_destacados[index].pfinal * counter).toFixed(2));
    }

    this.setState({
      productosOfertas: _destacados
    })
  }
  postAgregarProductoFavorito = (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _productosOfertas = this.state.productosOfertas
          _productosOfertas[index].favorito = !AplicaFavorito;

          this.setState({
            productosOfertas: _productosOfertas
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Ofertas", error.message ?? null);
        });
      });
  }
  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, item, pantalla) => {

    this.setState({ loading: true })

    let producto = {
      codigo: item.matnr,
      descripcion: item.maktx,
      precioOferta: item.poferta,
      precioPublico: item.plista,
      precioFinal: item.pfinal,
      precioPVD: item.precioPVD,
      precioPVP: item.precioPVP,
      precioPublico: item.precioPublico,
      meins: item.meins,
      moneda: item.waers,
      cantidadOriginal: item.cantidad,
      cantidad: item.cantidad,
      pantalla: pantalla,
      pathI: item.pathImage,
      precios: item.precios,
      escalas: item.escalas
    };

    AgregarProductoCarrito(this.state.dealer, this.state.linea, this.state.asociado, producto)
      .then(result => {
        if (result.mo.type == "success") {
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;
          let _destacados = this.state.productosOfertas
          _destacados[item.indice].cantidad = 0;
          _destacados[item.indice].subTotal = 0;

          setcarritoProdctos(result.dto.carritoProdctos);
          this.setState({
            loading: false,
            alertas: result.dto.alertas,
            datosTotal: {
              total: _total,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            productosOfertas: _destacados,
            addToCart: true,
            dataToCard: producto
          })



        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Buscador", error.message ?? null);
        });
      });
  }
}